import { z } from "zod";
import { EntityType } from "../entityType.js";

export const FavoriteSchema = z.object({
  id: z.uuid(),
  organizationId: z.uuid(),
  creatorId: z.string(),
  entityType: z.union([z.enum(EntityType), z.string()]),
  entityId: z.string(),
  createdAt: z.date(),
});

export const FilterFavoriteParamsSchema = z.object({
  entityType: FavoriteSchema.shape.entityType,
  entityIds: z.array(FavoriteSchema.shape.entityId).optional(),
});

export const CreateFavoriteSchema = z.object({
  entityType: FavoriteSchema.shape.entityType,
  entityId: FavoriteSchema.shape.entityId,
});

export type Favorite = z.infer<typeof FavoriteSchema>;
export type FilterFavoriteParams = z.infer<typeof FilterFavoriteParamsSchema>;
export type CreateFavorite = z.infer<typeof CreateFavoriteSchema>;
